module.exports = __webpack_public_path__ + "media/images/landing/avatar3-8dafa350f34354aab4798efe1d064f46.jpg";